export const getTreeBiomassLstTHead = (t) => [
  t("TREE_FORM.PREDOMINANT_TREE_CLASSIFICATION"),
  t("TREE_FORM.DENSITY"),
  t("TREE_FORM.DIAMETER_PREVIOUS_YEAR"),
  t("TREE_FORM.DIAMETER_CURRENT_YEAR"),
  t("TREE_FORM.UNIT_DIAMETER"),
  t("TREE_FORM.QTY_PLANTED_LOST_TREES"),
  t("TREE_FORM.UNIT_DENSITY"),
];
